import { observable } from "mobx";
import ExemptionCancellationApplicationRejectionReason from "./exemptionCancellationApplicationRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionCancellationApplicationProductionResponse {
  /**
   * If true - application is valid and can be submitted.
   */
  @observable
  canBeAppliedFor!: boolean;

  @observable
  rejectionReason?: ExemptionCancellationApplicationRejectionReason;
}
